import { RequestCommonData } from './request-common-data';
import { RequestNotification } from './request-notification';

export class RequestListItem {
  requestId: number;
  internalNumber: string;
  createdDate: Date;
  createdDateGroupValue: string;
  createdDateMoscow: Date;
  createdDateLocal: Date;
  externalId: string;

  updatedDate: Date;
  updatedDateLocal: Date;

  initTypeId: number;
  initTypeName: string;

  requestTypeId: number;
  requestTypeName: string;

  categoryId: number;
  categoryName: string;

  statusId: number;
  statusName: string;
  statusColor: string;

  performerUserId: number;
  performerUserName: string;

  openActivityPerformerUserName: string;

  performerUserGroupId: number;
  performerUserGroupName: string;

  utcTimezoneShift: number;
  utcTimezoneShiftString: string;

  authorUserId: number;
  authorUserName: string;

  authorUserGroupId: number;
  authorUserGroupName: string;

  customerContragentId: number;
  customerContragentName: string;

  description: string;

  tspAddress: string;

  finishDate: Date;
  finishDateMoscow: Date;
  finishDateLocal: Date;
  finishDateFactLocal: Date;

  stoppedUntil: Date;
  stoppedUntilMoscow: Date;
  stoppedUntilLocal: Date;

  endOfSlaDate: Date;
  endOfSlaDateMoscow: Date;
  endOfSlaDateLocal: Date;

  stateUpdateDate: Date;
  stateUpdateDateMoscow: Date;
  stateUpdateDateLocal: Date;

  attachmentTypesString: string;
  attachmentTypesCount: number;


  lastRequestComment: string;

  hasActivities: boolean;

  serviceNames: string;

  completedSerialNumbers: string;

  plannedDateLocal: Date;

	carrierId: number;
	carrierName: string;
	trackNumber: string;

	responsibleUserName: string;

	costCenterId: number;
	costCenterName: string;
	contragentProjectId: number;
	contragentProjectName: string;
}